export const ENDPOINTS = {
    groups: `/groups?tenant=RANGI`,
    register: `/register`,
};

class Request {
    constructor() {
        this._cache = {};
        this._baseUrl = "https://register.test.teaohunga.plink.co.nz";

        if (document.URL.match(/\/\/(www\.)?ngatirangi\.com/)) {
            this._baseUrl = "https://register.teaohunga.plink.co.nz";
        }
    }

    async _makeRequest(path, method, data) {
        const url = `${this._baseUrl}${path}`;

        try {
            const options = {
                method,
                mode: "cors",
                headers: { "Content-Type": "application/json" },
                body: null,
            };

            if (data) {
                options.body =
                    typeof data === "string" ? data : JSON.stringify(data);
            }

            const res = await fetch(url, options);
            const result = await res.json();

            return result;
        } catch (error) {
            console.error(error);
        }
    }

    async get(path) {
        if (this._cache[path]) {
            return this._cache[path];
        }

        const response = this._makeRequest(path, "GET");

        this._cache[path] = response;

        return this._cache[path];
    }

    post(path, data) {
        return this._makeRequest(path, "POST", data);
    }
}

export const request = new Request();
